module.exports = __webpack_public_path__ + "static/pic03-478b38275144e0682dbf0110c08e15d7.jpg";